// ESLint Settings
/* eslint no-unused-labels: "off", complexity: "off" */
/* globals TimelineMax: true, TweenMax: true, platformCheck: true, site: true */

(function ($) {
  'use strict';

  Drupal.behaviors.ModuleAerinSideNavV1 = {
    /* eslint-disable no-unused-vars */
    attach: function (context, settings) {
    /* eslint-enable no-unused-vars */
      // DOM
      var $window = $(window);
      var $sideNav = $('#aerin_nav', context); // Expected to be only one on the page
      var $sideNavContent = $sideNav.find('.aerin_nav-wrapper', context);
      // LOGIC
      var animationPlaying = false;
      var animation = new TimelineMax({ paused: true });
      var pageLabel;
      var platformVars = platformCheck({
        target: $sideNav[0],
        mobileSize: 767,
        isMobileCallback: function () {
          return typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
        }
      });
      var isDropdown = $sideNav.hasClass('dropdown');

      // BEGIN: Init
      init: {
        // Find current label outside of side nav
        pageLabel = $('[data-label]').not('.aerin_nav-wrapper [data-label]').attr('data-label');

        // Set up side nav mobile / Portrait / dropdown
        if (platformVars.isMobile || platformVars.orientation || isDropdown) {
          animation
            .to($sideNavContent.find('.nav-group-container').not('#section-footer'), 0.5, { y: '0%' })
            .to($sideNavContent.find('.shop-arrow-container'), 0.5, { rotation: '90deg' }, '0')
            .set($sideNavContent, { className: '+=active' })
            .addPause()
            .addLabel('exit', '+=0.1')
            .to($sideNavContent.find('.nav-group-container').not('#section-footer'), 0.5, { y: '-125%' })
            .to($sideNavContent.find('.shop-arrow-container'), 0.5, { rotation: '0deg' }, '-=0.5')
            .set($sideNavContent, { className: '-=active' });
        } else {
          animation
            .staggerFrom($sideNavContent.find('.nav_logo, dd, dt'), 0.5, {
              opacity: 0,
              x: '-=20%'
            }, 0.1);
        }

        // Mark <a> links in side nav that match current page label
        $sideNavContent.find('.nav-group a').each(function () {
          // DOM
          var $this = $(this);
          // LOGIC
          var label = $this.data('label');

          // Must have pageLabel or label
          if (typeof pageLabel === 'undefined' || typeof label === 'undefined') {
            return;
          }

          // pageLabel and label must not be empty strings
          if (pageLabel.trim().length === 0 || label.trim().length === 0) {
            return;
          }

          if (pageLabel === label) {
            $this.addClass('active');
          }
        });

        // Play side nav intro after a set time
        $window.load(function () {
          setTimeout(function () {
            if (animationPlaying) {
              return;
            }

            $window.trigger('playSideNavAnimation');
          }, 3000);
        });

        // Since we're not using preloader, immediately attempt to load images
        $sideNav.find('img').each(function () {
          // DOM
          var $this = $(this);
          // LOGIC
          var src = $this.attr('data-src');

          // data-src must be defined and not an empty string
          if (typeof src !== 'undefined' && src.trim().length !== 0) {
            $this.attr('src', src);
          }
        });
      }
      // END: Init

      // BEGIN: Events
      events: {
        $window
          .on('platformcheck-update', function (e) {
            // DOM
            var $animationTargets = $sideNavContent.find('.nav_logo, dd, dt, .nav-group-container, .shop-arrow-container');
            // LOGIC
            var flag = e.originalEvent.detail.flag;

            // Update platform vars
            platformVars = e.originalEvent.detail.platformVars;

            // Desktop mobile width detection
            if (platformVars.isDesktop && (flag & platformCheck.FLAG_MOBILE)) {
              if ($sideNav.hasClass('mobile')) {
                $sideNav.removeClass('mobile');
              } else {
                $sideNav.addClass('mobile');
              }
            }

            if (platformVars.isIpad && (flag & platformCheck.FLAG_ORIENTATION)) {
              if (platformVars.orientation) {
                $sideNav.addClass('js-ipad-portrait');
              } else if (platformVars.orientation === false) {
                $sideNav.removeClass('js-ipad-portrait');
              }
            }

            // If changes happened flag will not be 0
            // iPad needs to listen for orientation changes
            // Rebuild animation whenever the orientation / desktop-mobile changes
            if (flag !== 0) {
              $sideNavContent.find('*').removeAttr('style');

              // Stop all animation
              TweenMax.killTweensOf($sideNavContent.add($animationTargets));

              // Clear existing styles and classes
              $sideNavContent.add($animationTargets).removeAttr('style');
              $sideNavContent.removeClass('active');

              // Build mobile animation whenever orientation is portrait
              if (platformVars.orientation || platformVars.isMobile || isDropdown) {
                animation = new TimelineMax({ paused: true });

                animation
                  .to($sideNavContent.find('.nav-group-container').not('#section-footer'), 0.5, { y: '0%' })
                  .to($sideNavContent.find('.shop-arrow-container'), 0.5, { rotation: '90deg' }, '0')
                  .set($sideNavContent, { className: '+=active' })
                  .addPause()
                  .addLabel('exit', '+=0.1')
                  .to($sideNavContent.find('.nav-group-container').not('#section-footer'), 0.5, { y: '-125%' })
                  .to($sideNavContent.find('.shop-arrow-container'), 0.5, { rotation: '0deg' }, '-=0.5')
                  .set($sideNavContent, { className: '-=active' });

                animation.progress(0);
              }
            }
          })
          .one('loadAnimationComplete playSideNavAnimation', function () {
            if (animationPlaying) {
              return;
            }

            animationPlaying = true;

            if (platformVars.isDesktop && !platformVars.isMobile && !platformVars.isIpad && !isDropdown) {
              animation.play(0);

            // Play animation if orientation is iPad landscape
            } else if (platformVars.orientation === false) {
              animation.play(0);
            }
          });

        // Mobile / iPad Portrait event
        $sideNavContent.find('.nav_logo').on('click', function (e) {
          // Must be mobile or ipad portrait or a dropdown
          if (!platformVars.isMobile && !(platformVars.isIpad && platformVars.orientation) && !isDropdown) {
            return;
          }

          if (platformVars.isMobile || platformVars.orientation || isDropdown) {
            // Prevent normal link behavior and play animation
            e.preventDefault();

            if ($sideNavContent.hasClass('active')) {
              animation.play('exit');
            } else {
              animation.play(0);
            }
          }
        });
      }
      // END: Events
    }
  };
})(jQuery);
